interface LogoInterface {
    id?: string;
}

const Logo = (props: LogoInterface) => {
    return (
        <div>
            <a className="logo-link">
                <img id={`${props.id}-page-logo`} className="page-loading-logo" src={""} srcSet={"/images/logo.png"} alt="logo" />
            </a>
        </div>
    );
};

export default Logo;
